const events =
[{
  "date": "11/8/2024",
  "name": "Function-based well-modulated interface",
  "time": "3:45 PM - 5:45 PM",
  "description": "Ureteral anastomosis NEC"
}, {
  "date": "11/27/2024",
  "name": "Open-source tangible parallelism",
  "time": "10:30 AM - 12:30 AM",
  "description": "Destruct abd wall lesion"
}, {
  "date": "11/12/2024",
  "name": "Synergized zero defect data-warehouse",
  "time": "5:11 PM - 6:00 PM",
  "description": "Toxicology-eye"
}, {
  "date": "11/25/2024",
  "name": "Optional asynchronous Graphic Interface",
  "time": "10:30 AM - 12:20PM",
  "description": "Bladder reconstruction"
}, {
  "date": "11/10/2024",
  "name": "Profound zero administration functionalities",
  "time": "11:11 AM - 12:11PM",
  "description": "Endosc destruc bronc les"
}, {
  "date": "12/28/2024",
  "name": "Cross-platform solution-oriented task-force",
  "time": "1:55 PM - 3:55PM",
  "description": "Create cutanperiton fist"
}, {
  "date": "12/29/2024",
  "name": "Diverse needs-based matrices",
  "time": "5:55 PM - 6:00PM",
  "description": "Toe amputation"
}, {
  "date": "12/26/2024",
  "name": "Public-key executive core",
  "time": "1:00 PM - 3:00PM",
  "description": "Replace cast NEC"
}, {
  "date": "11/11/2024",
  "name": "Cross-group systematic budgetary management",
  "time": "2:05 PM - 4:00PM",
  "description": "Abd vein resect & anast"
}, {
  "date": "12/2/2024",
  "name": "Fundamental systemic monitoring",
  "time": "1:48 PM - 3:00PM",
  "description": "Dpt administration"
}, {
  "date": "11/28/2024",
  "name": "Public-key global frame",
  "time": "12:14 PM - 2:00PM",
  "description": "Repair conjunct lacerat"
}, {
  "date": "12/9/2024",
  "name": "Integrated methodical firmware",
  "time": "11:07 AM - 12:00PM",
  "description": "Patellar division NEC"
}, {
  "date": "12/2/2024",
  "name": "Object-based methodical definition",
  "time": "5:40 PM - 6:00PM",
  "description": "Carporadial fusion"
}, {
  "date": "11/6/2024",
  "name": "Self-enabling well-modulated parallelism",
  "time": "2:42 PM - 4:00PM",
  "description": "Frontal sinusectomy"
}, {
  "date": "11/29/2024",
  "name": "Compatible bifurcated intranet",
  "time": "3:15 PM - 5:00PM",
  "description": "Laser destruc rectal les"
}]

export default events
